import { z } from "zod";
import { discordSnowflakeSchema, normalizeAllowedParentChannelIds, } from "./guild-settings.js";
const textEncoder = new TextEncoder();
const SECRET_FIELD_PATTERN = /(?:api.?key|ciphertext|credential|envelope|fingerprint|nonce|password|secret|token)/i;
export const uuidSchema = z.uuid();
export const opaqueCursorSchema = z.string().min(1).max(256);
export function utf8ByteLength(value) {
    return textEncoder.encode(value).byteLength;
}
export function unicodeCodePointLength(value) {
    return Array.from(value).length;
}
export function normalizeNfcTrimmedText(value) {
    return value.normalize("NFC").trim();
}
export function boundedNfcTextSchema(maximumCodePoints, maximumBytes) {
    return z
        .string()
        .transform(normalizeNfcTrimmedText)
        .pipe(z
        .string()
        .min(1)
        .refine((value) => unicodeCodePointLength(value) <= maximumCodePoints, `Text must contain at most ${maximumCodePoints} Unicode code points`)
        .refine((value) => utf8ByteLength(value) <= maximumBytes, `Text must contain at most ${maximumBytes} UTF-8 bytes`));
}
export function normalizedSnowflakeListSchema(maximumItems, label) {
    return z
        .array(discordSnowflakeSchema)
        .max(maximumItems)
        .superRefine((values, context) => {
        if (new Set(values).size !== values.length) {
            context.addIssue({
                code: "custom",
                message: `${label} must be unique`,
            });
        }
    })
        .transform(normalizeAllowedParentChannelIds);
}
export function jsonUtf8ByteLength(value) {
    return utf8ByteLength(JSON.stringify(value));
}
export function containsSecretField(value) {
    if (Array.isArray(value))
        return value.some(containsSecretField);
    if (value === null || typeof value !== "object")
        return false;
    return Object.entries(value).some(([key, nestedValue]) => SECRET_FIELD_PATTERN.test(key) || containsSecretField(nestedValue));
}
export function sanitizedJsonObjectSchema(maximumBytes) {
    return z
        .record(z.string(), z.json())
        .refine((value) => !containsSecretField(value), "Sanitized JSON must not contain secret fields")
        .refine((value) => jsonUtf8ByteLength(value) <= maximumBytes, `JSON must contain at most ${maximumBytes} UTF-8 bytes`);
}
//# sourceMappingURL=platform-common.js.map